//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PLAS.js";
import "../no/Object.js";
import "../no/PDM.js";
import "../no/Part.js";
let d=[[[0,"ActiveControlLoop",1,"PLAS.Run",0],[0,"ActiveRun",1,"PLAS.Run",0]],[[["run"],"CreateRunBuilder",{R_:{builder:"PLAS.RunBuilder"}},1,0],[["run"],"CreateControlLoopBuilder",{R_:{builder:"PLAS.ControlLoopBuilder"}},1,0]],[]];
SPLM.PLAS.PlasManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.PLAS.PlasManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;